import React, { FC, ReactElement } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useStyles } from './styles';
import { ExportPrintButtons } from '../../ExportButtons';
import { ColumnConfig } from '../../../pages/Reports/DataTable/types';

interface Props {
  title: string;
  subTitle?: string;
  exportFileName: string;
  columns: ColumnConfig[];
  allData: any[];
  selectedColumns: string[];
  totalsRowBuilder?: (visibleCols: ColumnConfig[]) => string[];
  content?: ReactElement;
  fontSize?: number;
  printColumnNumber?: number;
  enableButtons: boolean;
  translation: any;
  reportNameInEn: string;
  sendEmail?: () => void;
}

export const ReportTitle: FC<Props> = ({ title, subTitle, exportFileName, fontSize, columns, allData, selectedColumns, totalsRowBuilder, content, printColumnNumber, enableButtons, translation, reportNameInEn, sendEmail }) => {
  const classes = useStyles();

  return (
    <Grid container direction="row" justify="space-between" alignContent="flex-start" alignItems="center" className={classes.root}>
      <Grid item xs={11}>
        <Grid container direction="column">
          <Typography className={classes.title}>{title}</Typography>
          {subTitle && (
            <Grid container direction="row" alignItems="center">
              <Typography className={classes.subTitle}>{subTitle}</Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item xs={1}>
        <ExportPrintButtons
          title={title}
          sendEmail={sendEmail}
          fontSize={fontSize}
          exportFileName={exportFileName}
          columns={columns}
          allData={allData}
          selectedColumns={selectedColumns}
          totalsRowBuilder={totalsRowBuilder}
          content={content}
          printColumnNumber={printColumnNumber}
          enableButtons={enableButtons}
          translation={translation}
          reportNameInEn={reportNameInEn}
        />
      </Grid>
    </Grid>
  );
};
